import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppConfigService } from "../services/app-config.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(    
    private appConfig: AppConfigService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    if (!request.url.startsWith(environment.url)) return next.handle(request);

    return next.handle(request);
  }

  
}
